var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TzDialog',_vm._g(_vm._b({ref:"dialog",staticClass:"ic-dialog",attrs:{"lock-scroll":_vm.lockScroll,"closed-by":_vm.closedBy},nativeOn:{"click":function($event){return _vm.handleHashNavigation.apply(null, arguments)}}},'TzDialog',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }